export default __webpack_public_path__ + "static/media/feature-image6.9fca67e3.png";